import React from 'react';
import ReactDOM from 'react-dom';
import Root from './router/AppRouter';
import { createStore } from 'redux'
import { Provider } from "react-redux";
// import 'antd/dist/antd.css';
import './style/global.less';
import reducer from "./redux/reducer";
import reportWebVitals from './reportWebVitals';
import { Quill } from 'react-quill';
import "./locales/i18n";
import 'intersection-observer';

let store = createStore(reducer)
// 注册quill
window.Quill = Quill;

ReactDOM.render(<Provider store={store}><Root /></Provider>, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
reportWebVitals();
